export default "__VITE_ASSET__rnZ1AaGk__"